const AppConfig = {
  api: {
    url: 'https://api.xosodevelop.com/api/'
  }
}

export default AppConfig;
